// extracted by mini-css-extract-plugin
module.exports = {"text":"CodeBlock_text__L4Z59"};